import React from "react";

const RefundPolicy = () => {
  return (
    <div className="refund-policy">
      <h1>Return & Refund Policy</h1>
      <p><strong>Last updated on:</strong> 24/12/24</p>

      <p>Thank you for shopping at <a href="https://algoheads.com">algoheads.com</a>.</p>
      <p>The following terms are applicable for any products that you have purchased from us.</p>

      <h2>Eligibility for Refunds</h2>
      <p>We offer refunds under the following circumstances:</p>
      <ul>
        <li>If the service is not delivered as promised due to an error on our end.</li>
        <li>If a technical issue caused by our platform prevents you from accessing the features you paid for, and the issue cannot be resolved within a reasonable timeframe.</li>
        <li>If you cancel your subscription within the refund period outlined below.</li>
      </ul>

      <h2>Refund Period</h2>
      <p>Refund requests must be made within <strong>15 days</strong> of the payment date. Requests made after this period will not be eligible for a refund.</p>

      <h2>Non-Refundable Cases</h2>
      <p>Refunds will not be granted under the following conditions:</p>
      <ul>
        <li>If you change your mind after purchasing a subscription or service.</li>
        <li>If you fail to use the service during the subscription period.</li>
        <li>If the issue is caused by third-party software or tools not affiliated with our platform.</li>
      </ul>

      <h2>Refund Process</h2>
      <p>To request a refund, please follow these steps:</p>
      <ol>
        <li>Contact our support team at <a href="mailto:support@algoheads.com">support@algoheads.com</a>.</li>
        <li>Provide your payment receipt, order ID, and a detailed explanation of the issue.</li>
        <li>Our team will review your request and respond within <strong>3-5 business days</strong>.</li>
        <li>If your request is approved, the refund will be processed to your original payment method within <strong>7-10 business days</strong>.</li>
      </ol>

      <p><em>This policy has been generated by dodopayments.com.</em></p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Refund Policy or require assistance, please reach out to us:</p>
      <p><strong>Email:</strong> <a href="mailto:support@algoheads.com">support@algoheads.com</a></p>
    </div>
  );
};

export default RefundPolicy;
